import { ChevronLeft, RefreshCw, Share2 } from 'lucide-react'
import { formatDistanceToNow } from '../../lib/relativeTime'

type Props = {
  itemCount:     number
  generatedAt:   string
  onBack:        () => void
  onRegenerate:  () => void
  onShare:       () => void
  regenerating?: boolean
}

export function ShoppingListMasthead({
  itemCount,
  generatedAt,
  onBack,
  onRegenerate,
  onShare,
  regenerating,
}: Props) {
  return (
    <header className="mb-5">
      <button
        onClick={onBack}
        className="mb-3 flex items-center gap-1 py-1 text-[13px] font-medium text-ink-muted"
      >
        <ChevronLeft className="h-[14px] w-[14px]" strokeWidth={1.7} />
        Back to Shop
      </button>

      <div className="pb-4 border-b border-border-sand">
        <div className="flex justify-between items-center mb-2">
          <div className="text-[10px] uppercase tracking-[0.18em] text-ink-muted font-medium">
            {itemCount} {itemCount === 1 ? 'item' : 'items'} · generated {formatDistanceToNow(generatedAt)}
          </div>
          <div className="flex gap-1">
            <button
              onClick={onRegenerate}
              disabled={regenerating}
              aria-label="Regenerate list"
              className="p-1.5 text-ink-muted hover:text-ink disabled:opacity-50"
            >
              <RefreshCw
                className={`h-4 w-4 ${regenerating ? 'animate-spin' : ''}`}
                strokeWidth={1.6}
              />
            </button>
            <button
              onClick={onShare}
              aria-label="Share list"
              className="p-1.5 text-ink-muted hover:text-ink"
            >
              <Share2 className="h-4 w-4" strokeWidth={1.6} />
            </button>
          </div>
        </div>

        <h1 className="font-serif text-[28px] font-normal tracking-[-0.015em] text-ink leading-[1.05]">
          Your <em className="italic">shopping list</em>
        </h1>
        <p className="font-serif text-[13px] italic text-ink-muted mt-1 leading-[1.4]">
          Tap items as you grab them. We'll update the pantry when you unpack.
        </p>
      </div>
    </header>
  )
}
